import { render, staticRenderFns } from "./VersionNotes.vue?vue&type=template&id=769bff3e&"
import script from "./VersionNotes.vue?vue&type=script&lang=js&"
export * from "./VersionNotes.vue?vue&type=script&lang=js&"
import style0 from "./VersionNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports